<template>
  <div class="show">
    <img
      v-show="jump"
      :src="require(`../assets/img/animations/fullscreengifs/jump.gif`)"
      alt=""
    />
    <!-- <img
      v-show="!jump"
      :src="require(`../assets/img/animations/fullscreengifs/talk.gif`)"
      alt=""
    /> -->
    <audio id="currentSoundTag" ref="currentSoundTag">
      <source
        src="../assets/sound/fullscreensounds/introduction.mp3"
        type="audio/mpeg"
        autoplay
      />
    </audio>
  </div>
</template>

<script>
// import animationArr from '../config/constants';
// import { debuglog } from 'util';

export default {
  name: 'tutorial',
  components: {},
  data() {
    return {
      jump: true,
      soundtime: 6000
    };
  },
  created() {
    this.creatAnimation();
  },
  methods: {
    creatAnimation() {
      setTimeout(() => {
        var audio = document.getElementById('currentSoundTag');
        // console.log(audio.duration);
        this.soundtime = audio.duration;
        this.jump = false;
        setTimeout(() => {
          this.$refs.currentSoundTag.play();
        }, this.soundtime);
      }, 1300);
      setTimeout(() => this.$router.push('/belts-selection'), 7600);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/style.scss';
.show {
  width: 100%;
  height: 100%;
  background-image: url('../assets/img/login/background.jpg');
  background-size: contain;
}
</style>
